/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { QuestionnaireApplicableRulesDto } from '../../models/questionnaire-applicable-rules-dto';
import { ValidateAnswerDto } from '../../models/validate-answer-dto';

export interface QuestionnaireValidateAnswer$Plain$Params {
      body?: ValidateAnswerDto
}

export function questionnaireValidateAnswer$Plain(http: HttpClient, rootUrl: string, params?: QuestionnaireValidateAnswer$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<QuestionnaireApplicableRulesDto>> {
  const rb = new RequestBuilder(rootUrl, questionnaireValidateAnswer$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<QuestionnaireApplicableRulesDto>;
    })
  );
}

questionnaireValidateAnswer$Plain.PATH = '/v1/Questionnaire/ValidateAnswer';
